import React from 'react';
import { connect } from 'react-redux';
import {
	Button,
	Grid,
	IconButton,
	Snackbar,
	SnackbarContent,
	Typography,
	withStyles,
} from '@material-ui/core';
import { green, yellow } from '@material-ui/core/colors';
import { Close as CloseIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { disableSnackbar, userLoggedOut } from '../../actions/uiActions';
import { deleteLocalStorage } from '../../Auth/Auth0Service';
import {
	SNACKBAR_STATUS_ERROR,
	SNACKBAR_STATUS_SUCCESS,
	SNACKBAR_STATUS_WARNING,
} from '../../constants';
import * as css from './Header.css';

const styles = (theme) => ({
	button: {
		color: '#FFF',
		border: '3px solid #D5DBDE',
		borderRadius: '50px',
	},
	darkColor: {
		color: '#333',
	},
	marginLeft: {
		'margin-left': '10px',
	},
	[SNACKBAR_STATUS_SUCCESS]: {
		backgroundColor: green[600],
		color: '#fff',
	},
	[SNACKBAR_STATUS_WARNING]: {
		backgroundColor: yellow[600],
		color: 'black',
	},
	[SNACKBAR_STATUS_ERROR]: {
		backgroundColor: theme.palette.error.dark,
	},
});

function handleClose(reason, disable) {
	if (reason !== 'clickaway') {
		disable();
	}
}

class Header extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			animationIsRunning: false,
		};
	}

	componentDidUpdate() {
		const { isLoading } = this.props;
		const { animationIsRunning } = this.state;
		if (isLoading && !animationIsRunning) {
			this.setState({ animationIsRunning: true });
		}
	}

	render() {
		const {
			classes,
			isLoading,
			userName,
			logout,
			disable,
			snackbarMessage,
			snackbarStatus,
			isActivated,
		} = this.props;
		const { animationIsRunning } = this.state;

		const handleAnimationEnd = () => {
			if (!isLoading) {
				this.setState({ animationIsRunning: false });
			}
		};

		return (
			<div className={css.header}>
				<Grid container>
					<Grid item sm={8}>
						<div className={css.iconContainer}>
							<svg
								className={css.icon}
								xmlns="http://www.w3.org/2000/svg"
								width="342"
								height="42"
								viewBox="0 0 342 42"
							>
								<g fill="none" fillRule="evenodd">
									<g
										className={
											isLoading || animationIsRunning ? css.active : ''
										}
										fillRule="nonzero"
										onAnimationIteration={handleAnimationEnd}
									>
										<circle cx="20" cy="20" r="20" fill="#FFF9B7" />
										<path
											fill="#F8E71C"
											d="M20.16,40.00 C9.02593944,40.00 0,31.2940606 0,20.16 C0,9.02593944 9.02593944,0 20.16,0 C31.2940606,0 40.00,9.02593944 40.00,20.16 C40.00,31.2940606 31.2940606,40.00 20.16,40.00 Z M21.1357598,24.6232783 C21.014797,24.4125752 20.8414755,24.2374437 20.6329501,24.1152178 C19.9716375,23.7275932 19.1245534,23.9550595 18.7409348,24.6232783 L13.4791892,33.7886242 C13.356778,34.00185 13.2923077,34.2439764 13.2923077,34.4904807 C13.2923077,35.2629891 13.9120772,35.8892307 14.6766017,35.8892307 L25.200093,35.8892307 C25.4440495,35.8892307 25.6836736,35.8240872 25.8946957,35.7003977 C26.5560084,35.312773 26.781124,34.4568429 26.3975054,33.7886242 L21.1357598,24.6232783 Z M18.7411633,15.6967217 C18.8621261,15.9074248 19.0354476,16.0825563 19.2439729,16.2047822 C19.9052856,16.5924068 20.7523697,16.3649405 21.1359883,15.6967217 L26.3977339,6.53137584 C26.5201451,6.31814998 26.5846154,6.07602354 26.5846154,5.8295193 C26.5846154,5.05701096 25.9648458,4.43076923 25.2003214,4.43076923 L14.6768301,4.43076923 C14.4328735,4.43076923 14.1932495,4.49591286 13.9822273,4.6196023 C13.3209146,5.00722697 13.0957991,5.86315714 13.4794176,6.53137584 L18.7411633,15.6967217 Z M17.095439,23.3773906 C17.2158833,23.1669525 17.2795015,22.928584 17.279997,22.6858783 C17.2815685,21.9161667 16.6613337,21.2909132 15.8946636,21.2893355 L5.37895128,21.2676952 C5.13431001,21.2671918 4.89388096,21.3316051 4.68201497,21.4544112 C4.01805788,21.8392678 3.79056938,22.6916346 4.17390519,23.3582258 L9.45042833,32.5336894 C9.5727492,32.7463959 9.74888748,32.9228708 9.9610038,33.0452407 C10.6257452,33.4287302 11.4742758,33.1985925 11.8562498,32.5312139 L17.095439,23.3773906 Z M23.6676379,16.9426094 C23.5471936,17.1530475 23.4835754,17.391416 23.4830799,17.6341217 C23.4815084,18.4038333 24.1017433,19.0290868 24.8684133,19.0306645 L35.3841257,19.0523048 C35.6287669,19.0528082 35.8691959,18.9883949 36.0810619,18.8655888 C36.7450191,18.4807322 36.9725075,17.6283654 36.5891718,16.9617742 L31.3126486,7.78631062 C31.1903277,7.57360411 31.0141894,7.39712916 30.8020731,7.27475926 C30.1373317,6.89126981 29.2888012,7.12140748 28.9068271,7.78878612 L23.6676379,16.9426094 Z M15.8944296,19.0306644 C16.1361762,19.0301669 16.3736027,18.9662963 16.5832091,18.8453742 C17.2479504,18.4618848 17.4771787,17.6099877 17.0952047,16.9426089 L11.8560165,7.7887836 C11.7341302,7.57582574 11.5583525,7.39898863 11.3464866,7.27618241 C10.6825296,6.89132577 9.83353118,7.11971682 9.45019548,7.7863081 L4.17367336,16.9617737 C4.0513525,17.1744803 3.98719377,17.4158632 3.98769522,17.6614751 C3.98926672,18.4311868 4.61204937,19.0538824 5.37871921,19.0523047 L15.8944296,19.0306644 Z M24.8686474,21.2893356 C24.6269007,21.2898331 24.3894743,21.3537037 24.1798678,21.4746258 C23.5151265,21.8581152 23.2858983,22.7100123 23.6678723,23.3773911 L28.9070605,32.5312164 C29.0289468,32.7441743 29.2047244,32.9210114 29.4165903,33.0438176 C30.0805473,33.4286742 30.9295457,33.2002832 31.3128814,32.5336919 L36.5894036,23.3582263 C36.7117244,23.1455197 36.7758832,22.9041368 36.7753817,22.6585249 C36.7738102,21.8888132 36.1510276,21.2661176 35.3843577,21.2676953 L24.8686474,21.2893356 Z"
										/>
									</g>

									<rect
										width="47.52"
										height="5.76"
										x="38"
										y="18"
										fill="#F8E71C"
										fillRule="nonzero"
									/>
									<rect
										width="41.04"
										height="5.76"
										x="277"
										y="18"
										fill="#F8E71C"
										fillRule="nonzero"
									/>
									<path
										fill="#FFF"
										fillRule="nonzero"
										d="M105.9968,26.8112 L105.9968,30.008 L92,30.008 L92,11 L95.9744,11 L95.9744,26.8112 L105.9968,26.8112 Z M123.0464,27.5024 L122.7584,29.8928 C122.220798,30.1616013 121.596804,30.296 120.8864,30.296 C119.043191,30.296 117.939202,29.5760072 117.5744,28.136 C117.151998,28.8464036 116.499205,29.3839982 115.616,29.7488 C114.732795,30.1136018 113.686406,30.296 112.4768,30.296 C111.075193,30.296 109.980804,29.9792032 109.1936,29.3456 C108.406396,28.7119968 108.0128,27.800006 108.0128,26.6096 C108.0128,24.2671883 109.884781,22.7504035 113.6288,22.0592 L117.0848,21.3968 L117.0848,20.7056 C117.0848,19.9375962 116.868802,19.3280023 116.4368,18.8768 C116.004798,18.4255977 115.404804,18.2 114.6368,18.2 C113.753595,18.2 113.033603,18.3919981 112.4768,18.776 C111.919997,19.1600019 111.536001,19.7839957 111.3248,20.648 L108.1856,19.3232 C108.492802,18.0751938 109.183994,17.0960036 110.2592,16.3856 C111.334406,15.6751964 112.735991,15.32 114.464,15.32 C116.518411,15.32 118.121594,15.7663955 119.2736,16.6592 C120.425606,17.5520045 121.0016,18.8719913 121.0016,20.6192 L121.0016,26.5232 C121.0016,26.9072019 121.087999,27.1855991 121.2608,27.3584 C121.433601,27.5312009 121.702398,27.6176 122.0672,27.6176 C122.470402,27.6176 122.796799,27.5792004 123.0464,27.5024 Z M116.0336,26.9984 C116.734403,26.5855979 117.0848,26.0240036 117.0848,25.3136 L117.0848,23.816 L114.0032,24.5072 C113.350397,24.6608008 112.865601,24.8671987 112.5488,25.1264 C112.231999,25.3856013 112.0736,25.7455977 112.0736,26.2064 C112.0736,26.6672023 112.217599,27.0175988 112.5056,27.2576 C112.793601,27.4976012 113.196797,27.6176 113.7152,27.6176 C114.560004,27.6176 115.332797,27.4112021 116.0336,26.9984 Z M124.3424,27.5312 L126.6464,25.1696 C127.030402,25.9952041 127.582396,26.5759983 128.3024,26.912 C129.022404,27.2480017 129.910395,27.416 130.9664,27.416 C131.811204,27.416 132.463998,27.3008012 132.9248,27.0704 C133.385602,26.8399988 133.616,26.523202 133.616,26.12 C133.616,25.7935984 133.400002,25.5152012 132.968,25.2848 C132.535998,25.0543988 131.792005,24.8336011 130.736,24.6224 C128.527989,24.1807978 126.977604,23.6000036 126.0848,22.88 C125.191996,22.1599964 124.7456,21.1856061 124.7456,19.9568 C124.7456,19.150396 124.995197,18.3920036 125.4944,17.6816 C125.993603,16.9711964 126.732795,16.4000022 127.712,15.968 C128.691205,15.5359978 129.862393,15.32 131.2256,15.32 C132.838408,15.32 134.143995,15.5647976 135.1424,16.0544 C136.140805,16.5440024 136.975997,17.3167947 137.648,18.3728 L135.2,20.4464 C134.777598,19.6783962 134.254403,19.1120018 133.6304,18.7472 C133.006397,18.3823982 132.224005,18.2 131.2832,18.2 C130.495996,18.2 129.867203,18.3343987 129.3968,18.6032 C128.926397,18.8720013 128.6912,19.1983981 128.6912,19.5824 C128.6912,19.985602 128.921598,20.3215987 129.3824,20.5904 C129.843202,20.8592013 130.659194,21.1087988 131.8304,21.3392 C133.92321,21.7616021 135.406396,22.3135966 136.28,22.9952 C137.153604,23.6768034 137.5904,24.622394 137.5904,25.832 C137.5904,27.1760067 137.019206,28.2559959 135.8768,29.072 C134.734394,29.8880041 133.11681,30.296 131.024,30.296 C127.817584,30.296 125.590406,29.3744092 124.3424,27.5312 Z M154.0064,24.3056 L143.8112,24.3056 C144.214402,26.3408102 145.41439,27.3584 147.4112,27.3584 C148.236804,27.3584 148.918398,27.2048015 149.456,26.8976 C149.993602,26.5903985 150.367999,26.1488029 150.5792,25.5728 L153.8048,26.7536 C153.343998,27.9056058 152.571205,28.783997 151.4864,29.3888 C150.401595,29.993603 149.043208,30.296 147.4112,30.296 C145.030388,30.296 143.187206,29.6384066 141.8816,28.3232 C140.575994,27.0079934 139.9232,25.1696118 139.9232,22.808 C139.9232,20.4463882 140.556794,18.6080066 141.824,17.2928 C143.091206,15.9775934 144.876788,15.32 147.1808,15.32 C149.408011,15.32 151.121594,15.9631936 152.3216,17.2496 C153.521606,18.5360064 154.1216,20.3695881 154.1216,22.7504 C154.1216,23.2880027 154.0832,23.8063975 154.0064,24.3056 Z M144.8624,19.064 C144.295997,19.6208028 143.936,20.4463945 143.7824,21.5408 L150.4928,21.5408 C150.3392,20.4655946 149.974403,19.6448028 149.3984,19.0784 C148.822397,18.5119972 148.073604,18.2288 147.152,18.2288 C146.191995,18.2288 145.428803,18.5071972 144.8624,19.064 Z M167.1392,15.6368 L166.6496,19.0928 C166.207998,18.8047986 165.603204,18.6608 164.8352,18.6608 C163.894395,18.6608 163.083203,19.0015966 162.4016,19.6832 C161.719997,20.3648034 161.3792,21.3199939 161.3792,22.5488 L161.3792,30.008 L157.4336,30.008 L157.4336,15.608 L160.8608,15.608 L161.12,18.4304 C161.907204,16.3567896 163.395189,15.32 165.584,15.32 C166.256003,15.32 166.774398,15.4255989 167.1392,15.6368 Z M192.2816,26.8112 L192.2816,30.008 L178.2848,30.008 L178.2848,11 L182.2592,11 L182.2592,26.8112 L192.2816,26.8112 Z M208.2656,24.3056 L198.0704,24.3056 C198.473602,26.3408102 199.67359,27.3584 201.6704,27.3584 C202.496004,27.3584 203.177598,27.2048015 203.7152,26.8976 C204.252802,26.5903985 204.627199,26.1488029 204.8384,25.5728 L208.064,26.7536 C207.603198,27.9056058 206.830405,28.783997 205.7456,29.3888 C204.660795,29.993603 203.302408,30.296 201.6704,30.296 C199.289588,30.296 197.446406,29.6384066 196.1408,28.3232 C194.835194,27.0079934 194.1824,25.1696118 194.1824,22.808 C194.1824,20.4463882 194.815994,18.6080066 196.0832,17.2928 C197.350406,15.9775934 199.135988,15.32 201.44,15.32 C203.667211,15.32 205.380794,15.9631936 206.5808,17.2496 C207.780806,18.5360064 208.3808,20.3695881 208.3808,22.7504 C208.3808,23.2880027 208.3424,23.8063975 208.2656,24.3056 Z M199.1216,19.064 C198.555197,19.6208028 198.1952,20.4463945 198.0416,21.5408 L204.752,21.5408 C204.5984,20.4655946 204.233603,19.6448028 203.6576,19.0784 C203.081597,18.5119972 202.332804,18.2288 201.4112,18.2288 C200.451195,18.2288 199.688003,18.5071972 199.1216,19.064 Z M233.3936,16.6736 C234.363205,17.5760045 234.848,18.8719916 234.848,20.5616 L234.848,30.008 L230.9024,30.008 L230.9024,21.3392 C230.9024,20.340795 230.681602,19.6064024 230.24,19.136 C229.798398,18.6655976 229.193604,18.4304 228.4256,18.4304 C227.503996,18.4304 226.745603,18.7663966 226.1504,19.4384 C225.555197,20.1104034 225.2576,21.051194 225.2576,22.2608 L225.2576,30.008 L221.312,30.008 L221.312,21.3392 C221.312,20.340795 221.091202,19.6064024 220.6496,19.136 C220.207998,18.6655976 219.593604,18.4304 218.8064,18.4304 C217.942396,18.4304 217.198403,18.7615967 216.5744,19.424 C215.950397,20.0864033 215.6384,21.0703935 215.6384,22.376 L215.6384,30.008 L211.6928,30.008 L211.6928,15.608 L215.2352,15.608 L215.3504,18.1712 C215.830402,17.2303953 216.487996,16.5200024 217.3232,16.04 C218.158404,15.5599976 219.094395,15.32 220.1312,15.32 C221.206406,15.32 222.161596,15.5695975 222.9968,16.0688 C223.832004,16.5680025 224.441598,17.2879953 224.8256,18.2288 C225.286402,17.2879953 225.958395,16.5680025 226.8416,16.0688 C227.724805,15.5695975 228.684795,15.32 229.7216,15.32 C231.200008,15.32 232.423995,15.7711955 233.3936,16.6736 Z M250.9616,17.3072 C252.257606,18.6320066 252.9056,20.4655883 252.9056,22.808 C252.9056,25.1504117 252.257606,26.9839934 250.9616,28.3088 C249.665594,29.6336066 247.856012,30.296 245.5328,30.296 C243.209588,30.296 241.400006,29.6336066 240.104,28.3088 C238.807994,26.9839934 238.16,25.1504117 238.16,22.808 C238.16,20.4655883 238.807994,18.6320066 240.104,17.3072 C241.400006,15.9823934 243.209588,15.32 245.5328,15.32 C247.856012,15.32 249.665594,15.9823934 250.9616,17.3072 Z M242.984,19.3952 C242.398397,20.1536038 242.1056,21.2911924 242.1056,22.808 C242.1056,24.3248076 242.398397,25.4623962 242.984,26.2208 C243.569603,26.9792038 244.419195,27.3584 245.5328,27.3584 C246.646405,27.3584 247.495997,26.9792038 248.0816,26.2208 C248.667203,25.4623962 248.96,24.3248076 248.96,22.808 C248.96,21.2911924 248.667203,20.1536038 248.0816,19.3952 C247.495997,18.6367962 246.646405,18.2576 245.5328,18.2576 C244.419195,18.2576 243.569603,18.6367962 242.984,19.3952 Z M268.6448,16.6736 C269.595205,17.5760045 270.0704,18.8719916 270.0704,20.5616 L270.0704,30.008 L266.1248,30.008 L266.1248,21.7136 C266.1248,19.5247891 265.270408,18.4304 263.5616,18.4304 C262.639996,18.4304 261.857603,18.7567967 261.2144,19.4096 C260.571197,20.0624033 260.2496,21.0607933 260.2496,22.4048 L260.2496,30.008 L256.304,30.008 L256.304,15.608 L259.8464,15.608 L259.9616,18.1712 C260.441602,17.2303953 261.103996,16.5200024 261.9488,16.04 C262.793604,15.5599976 263.772795,15.32 264.8864,15.32 C266.441608,15.32 267.694395,15.7711955 268.6448,16.6736 Z"
									/>
									<path
										fill="#F8E71C"
										d="M337,25.4218036 C337,23.9529285 335.833267,19.8123273 333.499801,13 C331.1666,19.8123273 330,23.9529285 330,25.4218036 C330,27.6251162 331.562639,29.0310393 333.499801,29.0310393 C335.437494,29.0310393 337,27.6406549 337,25.4218036 Z"
										transform="rotate(-90 333.5 21.016)"
									/>
									<path
										fill="#F8E71C"
										d="M332,17.4451327 C332,15.9762576 330.833267,11.8356564 328.499801,5.0233291 C326.1666,11.8356564 325,15.9762576 325,17.4451327 C325,19.6484453 326.562639,21.0543684 328.499801,21.0543684 C330.437494,21.0543684 332,19.663984 332,17.4451327 Z"
										transform="rotate(-120 328.5 13.039)"
									/>
									<path
										fill="#F8E71C"
										d="M332,33.4451327 C332,31.9762576 330.833267,27.8356564 328.499801,21.0233291 C326.1666,27.8356564 325,31.9762576 325,33.4451327 C325,35.6484453 326.562639,37.0543684 328.499801,37.0543684 C330.437494,37.0543684 332,35.663984 332,33.4451327 Z"
										transform="scale(-1 1) rotate(60 0 -539.94)"
									/>
								</g>
							</svg>
						</div>
					</Grid>
					<Grid
						container
						item
						alignItems="center"
						justifyContent="space-evenly"
						sm={4}
					>
						<Button variant="outlined" className={classes.button}>
							<Typography className={classes.buttonTypography} variant="button">
								{userName}
							</Typography>
						</Button>
						<Button variant="outlined" className={classes.button}>
							<Typography
								className={classes.buttonTypography}
								variant="button"
								onClick={() => deleteLocalStorage(() => logout())}
							>
								Log Out
							</Typography>
						</Button>
					</Grid>
					<Snackbar
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'right',
						}}
						open={isActivated}
						autoHideDuration={6000}
						onClose={(event, reason) => handleClose(reason, disable)}
					>
						<SnackbarContent
							classes={{ root: classes[snackbarStatus] }}
							message={<span id="message-id">{snackbarMessage || ''}</span>}
							action={[
								<IconButton
									key="close"
									aria-label="Close"
									color="inherit"
									onClick={() => disable()}
								>
									<CloseIcon />
								</IconButton>,
							]}
						/>
					</Snackbar>
				</Grid>
			</div>
		);
	}
}

Header.propTypes = {
	classes: PropTypes.object,
	isLoading: PropTypes.bool,
	userName: PropTypes.string,
	logout: PropTypes.func,
	disable: PropTypes.func,
	snackbarMessage: PropTypes.string,
	snackbarStatus: PropTypes.string,
	isActivated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
	isLoading: state.ui.isFetchingConfigData,
	userName: state.ui.userInformation.profile.name,
	snackbarMessage: state.ui.snackbar.notifications[0]
		? state.ui.snackbar.notifications[0].message
		: undefined,
	snackbarStatus: state.ui.snackbar.notifications[0]
		? state.ui.snackbar.notifications[0].status
		: undefined,
	isActivated: state.ui.snackbar.isActivated,
});

const mapDispatchToProps = (dispatch) => ({
	logout: () => dispatch(userLoggedOut()),
	disable: () => dispatch(disableSnackbar()),
});

const EnhancedHeader = connect(
	mapStateToProps,
	mapDispatchToProps,
)(withStyles(styles)(Header));

export { EnhancedHeader as Header };
